'use client';

import { ThemeProvider } from 'next-themes';
import type { FC } from 'react';
import { Toaster } from 'sonner';

import type { TProviders } from '@/lib/interfaces/common/providers.types';

const Providers: FC<TProviders> = ({ children, defaultTheme = 'system' }) => {
  return (
    <ThemeProvider
      attribute='class'
      defaultTheme={defaultTheme}
      enableSystem
      disableTransitionOnChange
      storageKey='bunker-suite-theme'
      enableColorScheme
    >
      {children}
      <Toaster position='bottom-right' richColors closeButton />
    </ThemeProvider>
  );
};

export default Providers;
